import { Box, Chip, Tooltip, Typography } from "@mui/material";
import { ExclusionSavingsResponse } from "@/services/dashboard/dashboard-api";
import { HTSCodeWithTooltip } from "@/components";
import { formatCurrency } from "@/utils";
import { tokens } from "@/tokens";

export const createExclusionsColumns = (): IColumn<ExclusionSavingsResponse["data"][number]>[] => [
  {
    name: "HTS Code",
    key: "htsCode",
    align: "left",
    width: "16%",
    component: (row) => (
      <HTSCodeWithTooltip htsCode={row.htsCode}>
        <Box sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', cursor: 'pointer', '&:hover': { color: tokens.brand.primary, textDecoration: 'underline' } }}>
          {row.htsCode}
        </Box>
      </HTSCodeWithTooltip>
    ),
    sorting: true,
  },
  {
    name: "99 Code",
    key: "code99",
    align: "left",
    width: "12%",
    component: (row) => (
      <Tooltip title={row.code99} arrow placement="top">
        <Box sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.code99}</Box>
      </Tooltip>
    ),
    sorting: true,
  },
  {
    name: "Entry Count",
    key: "entryCount",
    align: "left",
    width: "12%",
    component: (row) => <Typography variant="body2" sx={{ fontSize: { xs: tokens.fontSize.xs, md: tokens.fontSize.base } }}>{row.entryCount}</Typography>,
    sorting: true,
  },
  {
    name: "Status",
    key: "active",
    align: "left",
    width: "10%",
    component: (row) => (
      <Chip 
        label={row.active ? 'Active' : 'Expired'}
        color={row.active ? 'success' : 'error'}
        size="small"
        sx={{ color: !row.active ? tokens.bg.surface : undefined, backgroundColor: !row.active ? tokens.status.danger : undefined, borderColor: !row.active ? tokens.status.danger : undefined }}
      />
    ),
  },
  {
    name: "Goods Value",
    key: "goodsValue",
    align: "left",
    width: "14%",
    component: (row) => <Typography variant="body2" sx={{ fontSize: { xs: tokens.fontSize.xs, md: tokens.fontSize.base } }}>{formatCurrency(row.goodsValue)}</Typography>,
    sorting: true,
  },
  {
    name: "Current Duty Rate",
    key: "oldDutyRate",
    align: "left",
    width: "12%",
    component: (row) => <Typography variant="body2" sx={{ fontSize: { xs: tokens.fontSize.xs, md: tokens.fontSize.base } }}>{row.oldDutyRate}</Typography>,
    sorting: true,
  },
  {
    name: "New Duty Rate",
    key: "newDutyRate",
    align: "left",
    width: "12%",
    component: (row) => <Typography variant="body2" sx={{ fontSize: { xs: tokens.fontSize.xs, md: tokens.fontSize.base } }}>{row.newDutyRate}</Typography>,
    sorting: true,
  },
  {
    name: "Potential Savings",
    key: "savings",
    align: "left",
    width: "12%",
    sorting: true,
    component: (row) => (
      <Typography variant="body2" sx={{ fontSize: { xs: tokens.fontSize.xs, md: tokens.fontSize.base }, color: tokens.brand.primary, fontWeight: tokens.fontWeight.bold }}>
        {formatCurrency(row.savings)}
      </Typography>
    ),
  },
  {
    name: "Description",
    key: "description",
    align: "left",
    width: "20%",
    component: (row) => (
      <Tooltip title={row.description} placement="top-start">
        <Typography component="p" sx={{
          maxWidth: 400,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
          lineHeight: '1.2em',
          maxHeight: '3.6em',
          whiteSpace: 'normal',
          margin: 0,
          fontSize: tokens.fontSize.xs,
        }}>
          {row.description}
        </Typography>
      </Tooltip>
    ),
  },
];

export const exclusionsColumns: IColumn<ExclusionSavingsResponse["data"][number]>[] = createExclusionsColumns();


